module.exports = __webpack_public_path__ + "img/bg_login.6f79c9f0.jpg";